module.exports = __webpack_public_path__ + "img/teacher05.01fa7d4c.jpeg";